import { PublicKey } from '@solana/web3.js';

// Fee Configuration
export const FEE_CONFIG = {
  RECEIVER: new PublicKey(process.env.NEXT_PUBLIC_FEE_RECEIVER || '8347h8LeaVAUzyWES3Xj2Gd6QTpGrCayKBpuYvBW3PWD'),
  CREATION_FEE: Number(process.env.NEXT_PUBLIC_CREATION_FEE || 0.05),
  CREATION_FEE_PRO: Number(process.env.NEXT_PUBLIC_CREATION_FEE_PRO || 0.1),
};

// Address Lookup Table addresses (created via scripts/create-alt.js, one per network).
// Used by the Pro create-token flow to compress account references in the v0 transaction.
const ALT_MAINNET_RAW = process.env.NEXT_PUBLIC_ALT_MAINNET || '';
const ALT_DEVNET_RAW = process.env.NEXT_PUBLIC_ALT_DEVNET || '';

function safePk(raw: string): PublicKey | null {
  if (!raw) {return null;}
  try { return new PublicKey(raw); } catch { return null; }
}

export const ALT = {
  MAINNET: safePk(ALT_MAINNET_RAW),
  DEVNET: safePk(ALT_DEVNET_RAW),
};

export function getActiveAlt(network: string): PublicKey | null {
  if (network === 'mainnet-beta') {return ALT.MAINNET;}
  return ALT.DEVNET;
}

// Token Creation Limits
export const TOKEN_LIMITS = {
  MAX_NAME_LENGTH: 32,
  MAX_SYMBOL_LENGTH: 10,
  MAX_DECIMALS: 9,
  MIN_DECIMALS: 1,
  MAX_INITIAL_SUPPLY: 1000000000000,
  MAX_DESCRIPTION_LENGTH: 1000,
};

// File Upload Configuration
export const UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  DEFAULT_TOKEN_IMAGE: 'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png',
};

// Feature Flags
export const FEATURES = {
  ENABLE_TOKEN_PREVIEW: process.env.NEXT_PUBLIC_ENABLE_TOKEN_PREVIEW !== 'false',
  // Token-2022 Confidential Transfer extension. Disabled in the UI by default.
  // Flip to true (or set NEXT_PUBLIC_ENABLE_CONFIDENTIAL_TRANSFER=true) to
  // re-expose the toggle, preset, and Manage-page auditor decrypt tools. The
  // wire-format utils and parsers are intentionally kept in the bundle so
  // re-enabling is a single flag flip.
  ENABLE_CONFIDENTIAL_TRANSFER: process.env.NEXT_PUBLIC_ENABLE_CONFIDENTIAL_TRANSFER === 'true',
  // Single-use 10%-off codes issued after each successful mint. Requires
  // DATABASE_URL on the server; set NEXT_PUBLIC_ENABLE_DISCOUNT_CODES=false
  // to hide the UI without a redeploy of the database.
  ENABLE_DISCOUNT_CODES: process.env.NEXT_PUBLIC_ENABLE_DISCOUNT_CODES !== 'false',
};

// Error Messages
export const ERROR_MESSAGES = {
  WALLET_NOT_CONNECTED: 'Please connect your wallet to continue',
  INVALID_TOKEN_NAME: 'Token name must be between 1 and 32 characters',
  INVALID_TOKEN_SYMBOL: 'Token symbol must be between 1 and 10 characters',
  INVALID_DECIMALS: 'Decimals must be between 0 and 9',
  INVALID_SUPPLY: 'Initial supply must be a positive number',
  FILE_TOO_LARGE: 'Image file size must be less than 5MB',
  INVALID_FILE_TYPE: 'Invalid file type. Please upload a JPEG, PNG, GIF, or WebP image',
}; 